import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPharmacyTable, IPharmacyTableItem, ITableCatalogProductsResponse, ITableSinleRowPrice } from '@interfaces';

@Component({
  selector: 'bz-prices-table',
  templateUrl: './bz-prices-table.component.html',
  styleUrls: ['./bz-prices-table.component.sass']
})
export class BzPricesTableComponent {

  @Input() public table: ITableCatalogProductsResponse | IPharmacyTable | null = null;
  @Input() public lang: string = '';
  @Input() public tableHeading: string = '';
  @Input() public isListPage: boolean = false;
  @Input() public isCatalogPage: boolean = false;
  @Input() public isPharmacyPage: boolean = false;
  @Input() public isPreparatPage: boolean = false;

  @Output() public onResetCategoryPage: EventEmitter<void> = new EventEmitter();

  public get tableItems(): IPharmacyTableItem[] | ITableSinleRowPrice[] {
    return this.isPharmacyPage || this.isPreparatPage ?
      (this.table as IPharmacyTable).items :
      (this.table as ITableCatalogProductsResponse).prices;
  }

  public resetCategoryPage(): void {
    this.onResetCategoryPage.emit();
  }

}
